import { FC } from 'react'
import { Spinner } from '@platform/ui'
import styles from '@/components/courses/CoursesList/CoursesList.module.scss'
import { useLoadEnrolledCourses } from '@/components/courses/CoursesList/hooks/useLoadEnrolledCourses'
import { CoursesListHeader } from '@/components/courses/CoursesListHeader/CoursesListHeader'
import { useCoursesTitle } from '@/hooks/useCoursesTitle'
import { usePreselectFilters } from '@/hooks/usePreselectFilters'
import { useAppSelector } from '@/store/hooks'
import { EmptySearchResults } from '@/views/Catalog/components/CatalogList/components/EmptySearchResults/EmptySearchResults'
import { CourseFilterButton } from './components/CourseFilterButton/CourseFilterButton'
import { CoursesListRender } from './components/CoursesListRender/CoursesListRender'
import { EnrolledCoursesSearch } from './components/EnrolledCoursesSearch/EnrolledCoursesSearch'
import { useQueryEnrolledCourses } from './hooks/useQueryEnrolledCourses'
import { CollectionTagList } from '../../CollectionTagList/CollectionTagList'
import { EmptyCourses } from '../EmptyCourses/EmptyCourses'

const Courses = () => {
  const title = useCoursesTitle()

  const { enrolledCourses, totalEnrolledCourses } = useQueryEnrolledCourses()

  const searchText = useAppSelector((state) => state.aggregates.enrolledCoursesSearchText)

  usePreselectFilters('enrolled')

  return (
    <>
      <CoursesListHeader>
        <h1 data-qa="my-courses-title" className={styles.title}>
          {title}
        </h1>
        <EnrolledCoursesSearch />
      </CoursesListHeader>

      <div className={styles.container}>
        <CollectionTagList type="enrolled" />
        <CourseFilterButton type="enrolled" />
      </div>

      {!searchText && !enrolledCourses.length ? <EmptyCourses /> : null}
      {searchText && !enrolledCourses.length ? <EmptySearchResults /> : null}

      {enrolledCourses.length ? (
        <CoursesListRender enrolledCourses={enrolledCourses} totalEnrolledCourses={totalEnrolledCourses} />
      ) : null}
    </>
  )
}

export const CoursesList: FC = () => {
  useLoadEnrolledCourses()

  const { isEnrolledCoursesLoading } = useQueryEnrolledCourses()

  if (!isEnrolledCoursesLoading) {
    return <Courses />
  }

  return (
    <div className={styles.spinnerWrapper}>
      <Spinner />
    </div>
  )
}
